


import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";

const AddExpenditure = () => {
  // const [date, setDate] = useState("");
  const [date, setDate] = useState(() => {
    const today = new Date();
    return today.toISOString().split("T")[0]; // format YYYY-MM-DD
  });

  const [stockList, setStockList] = useState([]);
  const [user_id, setUserId] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const [items, setItems] = useState([
    {
      id: Date.now(),
      name: "",
      availableQty: "",
      quantity: "",
      price: "",
      total: "",
    },
  ]);

  useEffect(() => {
    const storedUserId = localStorage.getItem("user_id");
    if (storedUserId) {
      setUserId(storedUserId);
    }
  }, []);

  useEffect(() => {
    const fetchStockList = async () => {
      if (!user_id) return; // only fetch when user_id is available
      try {
        const res = await axios.get(
          `https://ims-backend.indevconsultancy.in/admin-panel/main-stock/?user_id=${user_id}`
        );
        setStockList(res.data);
      } catch (error) {
        console.error("Error fetching stock list:", error);
      }
    };

    fetchStockList();
  }, [user_id]); // 👈 added dependency

  const handleAddRow = () => {
    setItems([
      ...items,
      {
        id: Date.now(),
        name: "",
        availableQty: "",
        quantity: "",
        price: "",
        total: "",
      },
    ]);
  };

  const handleRemoveRow = (id) => {
    setItems(items.filter((item) => item.id !== id));
  };

  // const handleChange = (id, field, value) => {
  //   setItems((prevItems) =>
  //     prevItems.map((item) =>
  //       item.id === id
  //         ? {
  //           ...item,
  //           [field]: value,
  //           total:
  //             field === "quantity" || field === "price"
  //               ? (
  //                 parseFloat(field === "quantity" ? value : item.quantity || 0) *
  //                 parseFloat(field === "price" ? value : item.price || 0)
  //               ).toFixed(2)
  //               : item.total,
  //         }
  //         : item
  //     )
  //   );
  // };

  const handleChange = (id, field, value) => {
    setItems((prevItems) =>
      prevItems.map((item) => {
        if (item.id === id) {
          if (field === "quantity") {
            const qty = parseFloat(value) || 0;
            const available = parseFloat(item.availableQty) || 0;

            if (qty > available) {
              return {
                ...item,
                quantity: value,
                error: "Quantity cannot be greater than Available Qty",
                total: "",
              };
            } else {
              return {
                ...item,
                quantity: value,
                error: "",
                total: (qty * (parseFloat(item.price) || 0)).toFixed(2),
              };
            }
          }

          return {
            ...item,
            [field]: value,
            error: item.error,
            total:
              field === "price"
                ? (
                  (parseFloat(item.quantity) || 0) *
                  (parseFloat(value) || 0)
                ).toFixed(2)
                : item.total,
          };
        }
        return item;
      })
    );
  };


  // Stock usable on the chosen date — stock purchased after that date is excluded
  const fetchAvailableOnDate = async (itemsId, onDate) => {
    const res = await axios.get(
      `https://ims-backend.indevconsultancy.in/admin-panel/available-quantity-on-date/`,
      { params: { items_id: itemsId, user_id: user_id, date: onDate } }
    );
    return res.data.available_qty;
  };

  const qtyError = (quantity, availableQty) =>
    (parseFloat(quantity) || 0) > (parseFloat(availableQty) || 0)
      ? "Quantity cannot be greater than Available Qty"
      : "";

  // Date changed → recalculate Available Qty for every selected row
  useEffect(() => {
    if (!date || !user_id) return;
    const rows = items.filter((it) => it.name);
    if (rows.length === 0) return;

    Promise.all(
      rows.map(async (it) => {
        const stock = stockList.find((s) => s.stock_name === it.name);
        if (!stock) return null;
        try {
          return { id: it.id, qty: await fetchAvailableOnDate(stock.items_id, date) };
        } catch (error) {
          console.error("Error fetching available quantity:", error);
          return null;
        }
      })
    ).then((results) => {
      setItems((prevItems) =>
        prevItems.map((item) => {
          const r = results.find((x) => x && x.id === item.id);
          return r
            ? { ...item, availableQty: r.qty, error: qtyError(item.quantity, r.qty) }
            : item;
        })
      );
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date]);

const handleStockSelect = async (id, selectedItemId) => {
  const stock = stockList.find((s) => s.items_id === selectedItemId);
  if (stock) {
    try {
      const availableQty = await fetchAvailableOnDate(selectedItemId, date);
      setItems((prevItems) =>
        prevItems.map((item) =>
          item.id === id
            ? {
                ...item,
                name: stock.stock_name,
                availableQty: availableQty,  // ✅ from API
                price: stock.unit,
              }
            : item
        )
      );
    } catch (error) {
      console.error("Error fetching available quantity:", error);
      setItems((prevItems) =>
        prevItems.map((item) =>
          item.id === id
            ? {
                ...item,
                name: stock.stock_name,
                availableQty: stock.quantity,
                price: stock.unit,
              }
            : item
        )
      );
    }
  }
};




  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate every row first, so a later row failing doesn't leave earlier rows saved
    const overLimit = items.find(
      (it) => (parseFloat(it.quantity) || 0) > (parseFloat(it.availableQty) || 0)
    );
    if (overLimit) {
      alert(
      `${overLimit.name}: Only ${overLimit.availableQty || 0} units are available on ${date}. ` +
      `Stock received after this date cannot be issued on this date.`
      );
     return;
  }

    setLoading(true);

    try {
      const prepared = items.map((it) => {
        let items_id = it.items_id ?? it.name;
        let stock_name = it.name ?? it.name;

        if (
          stockList &&
          stockList.length &&
          !stockList.some((s) => String(s.items_id) === String(items_id))
        ) {
          const found = stockList.find(
            (s) =>
              String(s.stock_name) === String(it.name) ||
              String(s.items_id) === String(it.name)
          );
          if (found) items_id = found.items_id;
        }

        const qty = parseFloat(it.quantity || "0") || 0;
        const price = parseFloat(it.price || "0") || 0;
        const total = qty * price;

        return {
          user_id,
          items_id: String(items_id ?? ""),
          stock_name: String(stock_name ?? ""),
          quantity: String(qty),
          unit_price: String(price),
          total: String(total.toFixed(2)),
          date: date || "",
        };
      });

      for (const p of prepared) {
        await axios.post(
          "https://ims-backend.indevconsultancy.in/admin-panel/expenditures/create/",
          p
        );
      }

      alert("Expenditure(s) added successfully!");
      navigate("/purchaseExpenditure");

      setDate("");
      setItems([
        {
          id: Date.now(),
          name: "",
          availableQty: "",
          quantity: "",
          price: "",
          total: "",
        },
      ]);
    } catch (err) {
      console.error("Submit error:", err);
      if (err.response?.data?.error) {
        alert(err.response.data.error);
      } else if (err.response) {
        alert(
          `Submit failed: ${err.response.status}\n${JSON.stringify(
            err.response.data
          )}`
        );
      } else if (err.request) {
        alert(
          "No response from server. Check network / CORS. See console Network tab for the request details."
        );
      } else {
        alert("Error in request setup: " + err.message);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container my-4">
      <div className="row">
        <div className="col-md-6 text-start">
          <h5>Add Expenditure</h5>
        </div>
        <div className="col-md-6 text-end">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb justify-content-end mb-0">
              <li className="breadcrumb-item">
                <Link to="/purchaseExpenditure">Expenditure List</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Add Expenditure
              </li>
            </ol>
          </nav>
        </div>
      </div>

      <div className="card mt-3">
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="mb-3 row">
              <div className="col-12">
                <label htmlFor="date" className="form-label">Date</label>
                <input
                  type="date"
                  className="form-control"
                  id="date"
                  name="date"
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                  required
                />
              </div>
            </div>

            {items.map((item) => (
              <div key={item.id} className="row g-2 mb-3 align-items-center">
                <div className="col-md-2">
                  <label className="form-label">Stock</label>
                  <select
                    className="form-select"
                    value={
                      stockList.find((s) => s.stock_name === item.name)
                        ?.items_id || ""
                    }
                    onChange={(e) =>
                      handleStockSelect(item.id, e.target.value)
                    }
                    required
                  >
                    <option value="">Select Stock</option>
                    {stockList.map((stock) => {
                      // ✅ Check if this stock is already selected in any other row
                      const isAlreadySelected = items.some(
                        (existingItem) => 
                          existingItem.id !== item.id && // not the current row
                          stockList.find((s) => s.stock_name === existingItem.name)?.items_id === stock.items_id
                      );
                      
                      return (
                        <option 
                          key={stock.items_id} 
                          value={stock.items_id}
                          disabled={isAlreadySelected}  // ✅ Disable if already selected
                        >
                          {stock.stock_name} {isAlreadySelected ? "(Already selected)" : ""}
                        </option>
                      );
                    })}
                  </select>
                </div>

                <div className="col-md-2">
                  <label className="form-label">Available Qty</label>
                  <input
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    className="form-control"
                    placeholder="Available Qty"
                    value={item.availableQty}
                    readOnly
                  />
                </div>

                <div className="col-md-2">
                  <label className="form-label">Quantity</label>
                  <div className="input-group">
                    <input
                      type="number"
                      onWheel={(e) => e.target.blur()}

                      className={`form-control ${item.error ? "is-invalid" : ""}`}
                      placeholder="Quantity"
                      value={item.quantity}
                      max={item.availableQty} // 👈 hard limit bhi laga diya
                      onChange={(e) => handleChange(item.id, "quantity", e.target.value)}
                      required
                    />
                    <span className="input-group-text">kg</span>
                  </div>
                  {item.error && (
                    <div className="text-danger small">{item.error}</div>
                  )}
                </div>


                <div className="col-md-2">
                  <label className="form-label">Price</label>
                  <div className="input-group">
                    <span className="input-group-text">₹</span>
                    <input
                      type="number"
                      onWheel={(e) => e.target.blur()}

                      className="form-control"
                      placeholder="Price"
                      value={item.price}
                      readOnly
                    />
                  </div>
                </div>

                <div className="col-md-2">
                  <label className="form-label">Total</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Total"
                    value={isNaN(item.total) ? "" : item.total}
                    readOnly
                  />
                </div>

                <div className="col-md-1">
                  <button
                    type="button"
                    className="btn btn-success w-100"
                    onClick={handleAddRow}
                  >
                    <i className="fas fa-plus"></i>
                  </button>
                </div>

                <div className="col-md-1">
                  <button
                    type="button"
                    className="btn btn-danger w-100"
                    onClick={() => handleRemoveRow(item.id)}
                    disabled={items.length === 1}
                  >
                    <i className="fas fa-minus"></i>
                  </button>
                </div>
              </div>
            ))}

            <div className="text-end">
              <button className="btn btn-secondary me-2" type="reset">
                Clear
              </button>
              <button
                className="btn btn-primary"
                type="submit"
                disabled={loading}
              >
                {loading ? "Submitting..." : "Submit"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddExpenditure;
